<template>
  <div class="home">
      <div class="top-result">
          <div class="row">
              <div class="col-md-12">
                  <div class="stat-result">
                      Final Exam 2021
                      <P>Diploma in Information Technology</p>
                  </div>
              </div>
          </div>
      </div>
      <div class="mid-result">
          <div class="row">
            <div class="col-md-4">
                <div class="res pass">Pass</div>
                <!-- <div class="res fail">Fail</div> -->
            </div>
            <div class="col-md-8">
              <div class="set-res">
                <span>MCQ: 25/40</span>
                <span>Essay: 4/5</span>
              </div> 
              <span class="to-m">Total 45%</span>
            </div>
          </div>
      </div>
      <div class="result-sheet">
          <div class="row">
            <div class="col-md-12">
                <div id="accordion">
                  <div class="card">
                    <div class="card-header" id="headingOne">
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          What is the capital of Colombo ?
                          <span class="excode">Question code: 3456787</span>
                        </button>
                      </h5>
                    </div>

                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                      <div class="card-body">
                          <div class="row">
                              <div class="col-md-10">
                                <div class="m-form__group form-group">
                                  <div class="row">
                                      <div class="col-md-3">
                                          <div class="question-img">
                                              <img src="media/icons/classroom.png" />
                                          </div>
                                      </div>
                                      <div class="col-md-9">
                                        <div class="row">
                                          <div class="col-md-6">
                                            <div class="m-radio-list">
                                              <label class="m-radio m-radio--state-success with-images correct-answer">
                                                <input disabled type="checkbox" name="example_2" value="1" checked>
                                                <div class="mark-status correct">
                                                    <img src="images/correct.png" />
                                                </div>
                                                <img class="answer-img" src="https://www.onlinecampus.lk/newsite/wp-content/uploads/2021/05/vision2.png"/>
                                                Success state
                                                <span></span>
                                                <div class="que-status">Correct</div>
                                              </label>
                                            </div>                                        
                                          </div>
                                          <div class="col-md-6">
                                            <div class="m-radio-list">
                                              <label class="m-radio m-radio--state-success with-images wrong-answer">
                                                <input disabled type="checkbox" name="example_2" value="2" checked>
                                                <div class="mark-status wrong">
                                                    <img src="images/close2.png" />
                                                </div>
                                                <img class="answer-img" src="https://www.onlinecampus.lk/newsite/wp-content/uploads/2021/05/vision2.png"/>
                                                Success state
                                                <span></span>
                                                <div class="que-status">wrong</div>
                                              </label>
                                            </div>                                        
                                          </div> 
                                          <div class="col-md-6">
                                            <div class="m-radio-list">
                                              <label class="m-radio m-radio--state-success wrong-answer without-image">
                                                <input disabled type="radio" name="example_2" value="2" checked>
                                                <div class="mark-status wrong">
                                                    <img src="images/close2.png" />
                                                </div>
                                                Success state
                                                <span></span>
                                                <div class="que-status">wrong</div>
                                              </label>
                                            </div>                                        
                                          </div>  
                                          <div class="col-md-6">
                                            <div class="m-radio-list">
                                              <label class="m-checkbox m-checkbox--state-success correct-answer without-image">
                                                <input disabled type="radio" name="checkimg" value="1" checked>
                                                <div class="mark-status correct">
                                                    <img src="images/correct.png" />
                                                </div>
                                                Success state
                                                <span></span>
                                                <div class="que-status">Correct</div>
                                              </label>
                                            </div>                                        
                                          </div>
                                          <div class="col-md-6">
                                            <div class="m-radio-list">
                                              <label class="m-checkbox m-checkbox--state-success wrong-answer without-image">
                                                <input disabled type="checkbox" name="checkimg" value="2" checked>
                                                <div class="mark-status wrong">
                                                    <img src="images/close2.png" />
                                                </div>
                                                Success state
                                                <span></span>
                                                <div class="que-status">wrong</div>
                                              </label>
                                            </div>                                        
                                          </div>   
                                          <div class="col-md-9">
                                            <div class="row">
                                              <div class="col-md-12">
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
                                                  labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                                  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                                              </div>                                                                                                                            
                                            </div>                                        
                                          </div>                                                                                                             
                                        </div>                                        
                                      </div>
                                  </div>
                                </div>                                
                              </div>
                              <div class="col-md-2 right-info">
                                <ul class="list-group">
                                  <li class="list-group-item">
                                    <img src="https://revampadmin.webcolms.com/assets/demo/default/custom/img/marks.png" />
                                    10 Marks
                                    </li>
                                  <li class="list-group-item">
                                    <img class="time" src="https://revampadmin.webcolms.com/assets/demo/default/custom/img/clock.png" />
                                    5 Mins</li>
                                </ul>                                
                              </div>
                          </div>  
                      </div>
                    </div>
                  </div>
                </div>              
            </div>
          </div>
      </div>
  </div>
</template>

<script>
  var Config = require('../router/Config')
  var Cookies = require('vue-cookies')
  // var userPermissions = Cookies.get('userPermissions')

  var startExam = {
    name: 'reviewexam',
    components: {},
    props: [],
    
  }
  export default startExam
</script>

<style scoped lang="scss">
    @import "../assets/scss/component/exam/exam";
</style>
